import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AppInput from "../Shared/AppInput";
import {useFormik} from "formik";
import * as yup from 'yup';
import MyOpinionLogo from '../../assets/images/MyOpinion_Logo_Head.png';
import useAlert from "../../hooks/useAlert";
import httpService from "../../services/http.service";
import * as logger from "../../services/logger.service";
import { handleFormError } from "../../services/errorHandler.service";
import AppAlert from "../Shared/AppAlert";
import {extractResponseValidationErrors} from "../../utils/index";
import {loggedOut} from "../../actions/authAction";
import {connect} from "react-redux";
import * as jwtService from "../../services/jwt.service";

const ForgotPassword = ({history, match, location, loggedOut, ...props}) => {
    const { t } = useTranslation();

	const initialValues = {
		email: ''
	};

	const [submitting, setSubmitting] = useState(false);
	const [alert, setAlert, onClose] = useAlert();

	useEffect(() => {
		jwtService.remove(loggedOut);
	}, []);

	const onSubmit = async (values) => {
		setSubmitting(true);
		setAlert(null);

		// L'adresse du lien est fixée par le serveur : on n'envoie que l'adresse e-mail.
		try {
			const {data} = await httpService.post(`/auth/forgot-password`, values);

			logger.success("Demande de réinitialisation de mot de passe envoyée");

			setAlert({
				type: 'success',
				message: t("Si un compte correspond à cette adresse, un lien de réinitialisation vient d'être envoyé.")
			});

			formik.resetForm(initialValues);

			setTimeout(() => {
				history.replace('/login');
			}, 4000);
		} catch (error) {
			// Gestion d'erreur sécurisée avec messages conviviaux
			handleFormError(error, setAlert, {
				customMessages: {
					422: extractResponseValidationErrors(error.response?.data)?.[0] || 
					     "L'adresse email fournie n'est pas valide.",
					429: t("Trop de demandes. Réessayez dans quelques instants."),
					500: "Une erreur s'est produite. Veuillez réessayer plus tard."
				}
			});
		} finally {
			setSubmitting(false);
		}
	}

	const formik = useFormik({
		initialValues,
		validationSchema: yup.object().shape({
			email: yup.string().ensure().email().required(t("Champ obligatoire"))
		}),
		onSubmit
	})

	return (
		<>
			<div className="pattern">
				<span className="red"/>
				<span className="indigo"/>
				<span className="blue"/>
				<span className="green"/>
				<span className="orange"/>
			</div>
			<div className="auth-main particles_js">
				<div className="auth_div vivify popIn">
					<div className="auth_brand">
						<Link className="navbar-brand" to="/">
							<img src={MyOpinionLogo} width={process.env.REACT_APP_AUTH_LOGO_HEIGHT} height={process.env.REACT_APP_AUTH_LOGO_WIDTH} className="d-inline-block align-top mr-2" alt={process.env.REACT_APP_APP_NAME} />
						</Link>
					</div>
					<div className="card forgot-pass">
						<div className="body">
							<p className="lead mb-3"><strong>{t("Oups")}</strong>,<br /> {t("Un soucis ?")}</p>
							<p>{t("Entrez votre adresse email : si un compte lui correspond, vous recevrez un lien pour choisir un nouveau mot de passe.")}</p>
							<form className="form-auth-small" onSubmit={formik.handleSubmit}>
								{alert && <AppAlert onClose={onClose} type={alert.type}>{alert.message}</AppAlert>}
								<AppInput
									label={t("Adresse email")}
									type="email"
									name="email"
									error={formik.errors.email}
									touched={formik.touched.email}
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									value={formik.values.email}
									required
								/>
								<button type="submit" disabled={submitting} className="btn btn-round btn-primary btn-lg btn-block font-weight-bold">
									{submitting ? t('Envoi en cours...') : t('Recevoir le lien de réinitialisation')}
								</button>
								<div className="bottom">
									<span className="helper-text">{t("Retour à la page de")} <Link to="/login">{t("connexion")}</Link></span>
								</div>
							</form>
						</div>
					</div>
				</div>
				<div id="particles-js"></div>
			</div>
		</>
	);
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
	loggedOut: (data) => dispatch(loggedOut(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
